//
// DISCLAIMER
//
// Copyright 2026 ArangoDB GmbH, Cologne, Germany
//

import type { CSSProperties } from "react";
import { Duration, Timestamp } from "../../api/googleTypes";
import { humanizeDuration } from "../../ui/lib";
import { DateTimePopupWithUTCAndLocalTime } from "../../util/dateAndTimeUtils/DateTime";

const hintStyle: CSSProperties = {
  fontSize: 12,
  color: "#374151",
  marginBottom: 12,
  lineHeight: 1.6,
  padding: "8px 10px",
  background: "#f3f4f6",
  borderRadius: 4,
};

/** AWS (and similar) volume modify cooldown — shared by size/perf/volume edits. Always shown. */
export const DiskRateLimitHint = ({
  lastDiskPerformanceUpdatedAt,
  lastDiskSizeUpdatedAt,
  diskRateLimitPeriod,
  diskRateLimitActive,
}: {
  lastDiskPerformanceUpdatedAt?: Timestamp;
  lastDiskSizeUpdatedAt?: Timestamp;
  diskRateLimitPeriod?: Duration;
  diskRateLimitActive?: Duration;
}) => (
  <div style={hintStyle}>
    <div>
      Last performance update:{" "}
      {lastDiskPerformanceUpdatedAt ? <DateTimePopupWithUTCAndLocalTime dateTime={lastDiskPerformanceUpdatedAt} label="Last updated at" /> : "—"}
    </div>
    <div>
      Last disk size update: {lastDiskSizeUpdatedAt ? <DateTimePopupWithUTCAndLocalTime dateTime={lastDiskSizeUpdatedAt} label="Last updated at" /> : "—"}
    </div>
    <div>
      Rate limit: {diskRateLimitPeriod ? humanizeDuration(diskRateLimitPeriod) : "—"}
      {diskRateLimitActive ? ` (active for ${humanizeDuration(diskRateLimitActive)})` : ""}
    </div>
  </div>
);
